"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LiveEventFeed = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_2 = require("@heroui/react");
var react_3 = require("@iconify/react");
var utils_1 = require("@doshexchnage/utils");
var LiveEventFeed = function (_a) {
    var user_id = _a.user_id;
    var _b = (0, react_1.useState)([]), events = _b[0], setEvents = _b[1];
    var _c = (0, react_1.useState)("connecting"), connectionStatus = _c[0], setConnectionStatus = _c[1];
    var eventSourceRef = (0, react_1.useRef)(null);
    var eventsContainerRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        if (!user_id)
            return;
        var sseUrl = "".concat(process.env.LETS_ACHIEVE_URL, "/events/").concat(user_id);
        var eventSource = new EventSource(sseUrl);
        eventSourceRef.current = eventSource;
        eventSource.onopen = function () {
            console.log("SSE connection established");
            setConnectionStatus("connected");
        };
        eventSource.onmessage = function (event) {
            try {
                var parsedData_1 = JSON.parse(event.data);
                if (parsedData_1.type === "custom_event") {
                    setEvents(function (prevEvents) { return __spreadArray([parsedData_1], prevEvents, true).slice(0, 100); });
                    scrollToTop();
                    return;
                }
                console.warn("Received event with unrecognized format:", parsedData_1);
            }
            catch (error) {
                console.error("Error parsing SSE event:", error);
            }
        };
        eventSource.onerror = function (error) {
            console.error("SSE connection error:", error);
            setConnectionStatus("disconnected");
        };
        return function () {
            eventSource.close();
            eventSourceRef.current = null;
        };
    }, [user_id]);
    var scrollToTop = function () {
        if (eventsContainerRef.current) {
            eventsContainerRef.current.scrollTo({
                top: 0,
                behavior: "smooth",
            });
        }
    };
    var getRelativeTime = function (timestamp) {
        var date = new Date(timestamp);
        var now = new Date();
        var seconds = Math.floor((now.getTime() - date.getTime()) / 1000);
        if (seconds < 10)
            return "just now";
        if (seconds < 60)
            return "".concat(seconds, "s ago");
        var minutes = Math.floor(seconds / 60);
        if (minutes < 60)
            return "".concat(minutes, "m ago");
        var hours = Math.floor(minutes / 60);
        if (hours < 24)
            return "".concat(hours, "h ago");
        var days = Math.floor(hours / 24);
        return "".concat(days, "d ago");
    };
    var getConnectionStatusChip = function () {
        switch (connectionStatus) {
            case "connected":
                return ((0, jsx_runtime_1.jsxs)(react_2.Chip, { size: "sm", color: "success", variant: "soft", children: [(0, jsx_runtime_1.jsx)(react_3.Icon, { icon: "solar:check-circle-bold" }), "Live"] }));
            case "connecting":
                return ((0, jsx_runtime_1.jsxs)(react_2.Chip, { size: "sm", color: "warning", variant: "soft", children: [(0, jsx_runtime_1.jsx)(react_3.Icon, { icon: "solar:refresh-bold", className: "animate-spin" }), "Connecting..."] }));
            case "disconnected":
                return ((0, jsx_runtime_1.jsxs)(react_2.Chip, { size: "sm", color: "danger", variant: "soft", children: [(0, jsx_runtime_1.jsx)(react_3.Icon, { icon: "solar:close-circle-bold" }), "Disconnected"] }));
        }
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-4 bg-white rounded-lg p-4 shadow-sm", style: { height: 'calc(100vh - 280px)' }, children: [(0, jsx_runtime_1.jsx)("div", { className: "flex justify-between items-center flex-shrink-0", children: (0, jsx_runtime_1.jsxs)("div", { className: "flex items-center gap-2", children: [(0, jsx_runtime_1.jsxs)("p", { className: "text-sm text-gray-600", children: [events.length, " live events"] }), getConnectionStatusChip()] }) }), (0, jsx_runtime_1.jsx)("div", { ref: eventsContainerRef, className: "flex flex-col gap-3 overflow-y-auto flex-1", children: events.length === 0 ? ((0, jsx_runtime_1.jsxs)("div", { className: "text-center py-16 text-gray-500", children: [(0, jsx_runtime_1.jsx)(react_3.Icon, { icon: "solar:podcast-linear", className: "text-6xl mx-auto mb-4" }), (0, jsx_runtime_1.jsx)("p", { className: "text-lg font-medium", children: "Waiting for live events..." }), (0, jsx_runtime_1.jsx)("p", { className: "text-sm mt-2", children: "Events will appear here as they happen" })] })) : ((0, jsx_runtime_1.jsx)(react_2.Accordion, { className: "px-0", children: events.map(function (event, index) {
                        var timestamp = event.timestamp;
                        var eventTitle = event.event_type;
                        return ((0, jsx_runtime_1.jsxs)(react_2.Accordion.Item, { id: index, "aria-label": eventTitle, className: "animate-in slide-in-from-top duration-300", children: [(0, jsx_runtime_1.jsx)(react_2.Accordion.Heading, { children: (0, jsx_runtime_1.jsxs)(react_2.Accordion.Trigger, { children: [(0, jsx_runtime_1.jsx)("div", { className: "w-10 h-10 rounded-full bg-default flex items-center justify-center text-purple-600 flex-shrink-0", children: (0, jsx_runtime_1.jsx)(react_3.Icon, { icon: "solar:smart-speaker-bold", className: "text-xl" }) }), (0, jsx_runtime_1.jsxs)("div", { className: "flex items-center justify-between gap-4 flex-grow", children: [(0, jsx_runtime_1.jsxs)("div", { className: "flex items-center gap-2", children: [(0, jsx_runtime_1.jsx)("span", { className: "font-semibold", children: eventTitle }), (0, jsx_runtime_1.jsx)(react_2.Chip, { size: "sm", color: "default", variant: "soft", children: "Custom" })] }), (0, jsx_runtime_1.jsxs)("div", { className: "flex items-center gap-2 text-xs text-gray-400", children: [(0, jsx_runtime_1.jsx)(react_3.Icon, { icon: "solar:clock-circle-linear" }), (0, jsx_runtime_1.jsx)("span", { children: getRelativeTime(timestamp) })] })] }), (0, jsx_runtime_1.jsx)(react_2.Accordion.Indicator, {})] }) }), (0, jsx_runtime_1.jsx)(react_2.Accordion.Panel, { children: (0, jsx_runtime_1.jsx)(react_2.Accordion.Body, { children: (0, jsx_runtime_1.jsxs)("div", { className: "pl-14 pr-4 pb-4", children: [(0, jsx_runtime_1.jsx)("div", { className: "text-xs bg-surface-secondary p-4 rounded-lg border border-default", children: (0, jsx_runtime_1.jsx)("pre", { className: "whitespace-pre-wrap break-words font-mono text-gray-700", children: JSON.stringify(event, null, 2) }) }), (0, jsx_runtime_1.jsxs)("div", { className: "mt-3 text-xs text-gray-400 flex items-center gap-2", children: [(0, jsx_runtime_1.jsx)(react_3.Icon, { icon: "solar:calendar-linear" }), (0, jsx_runtime_1.jsx)("span", { children: utils_1.Formatting.formatDateTime(new Date(timestamp), "yyyy-MM-dd HH:mm:ss") })] })] }) }) })] }, index));
                    }) })) })] }));
};
exports.LiveEventFeed = LiveEventFeed;
